import {
  NoUserActionMessage,
  ServerErrorMessage,
  UserActionRequiredMessage,
} from "@sgwt-widget/components-base";
import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { h } from "preact";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import { DealListDateRange } from "../../common/components/DealListExport/DealListDateRange";
import { IStoredData } from "../../common/components/DealListExport/Types";
import { MakeBackgroundExportDataApiCall } from "../../common/generic/generic-api";
import {
  GenericFilterBuilder,
  HandleCsvCallErrors,
} from "../../common/generic/generic-helper";
import { UserActionOnAuthErrorMessage } from "../../common/generic/generic-message";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { NBIKpis } from "../../common/generic/generic-nbi-domains";
import {
  IGenericColumns,
  IGenericCsvRequest,
  IGenericRequest,
} from "../../common/generic/generic-types";
import {
  BuildPortfolioFilters,
  GetPortfolioFilterAsofDate,
} from "../../common/portfolio/portfolio-filter";
import { IProps } from "../../common/portfolio/portfolio-types";
import {
  getAttrsWithColsSelected,
  getDefaultAttributes,
  getDefaultKpis,
  getKpisWithColsSelected,
} from "../utils/helper";
import { RawUserMessage } from "../../common/components/Messages/RawUserMessage";
import { find } from "lodash";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";
interface IState {
  fromDate: string;
  toDate: string;
  attrsSelected: string;
  kpisSelected: string;
  filters: string;
  visibleAttributes: any[];
  visibleKpis: any[];
  level: string;
  date: string;
  top?: number;
  dataLevel: string;
  specificFromDate: string;
  specificToDate: string;
  spinnerClass: string;
  btnText: string;
  statusText?: string;
}

const inheritedFilter = "coverage_inherited:0";
const displayNone = "display: none";

export class NbiExportDealListClass extends ApiBackedComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  private readonly currentDate = new Date();
  private attributes?: [{ field: string; headerName: string }];
  private kpis?: [{ field: string; headerName: string }];
  private readonly key: string;
  private readonly defaultData: IStoredData;
  private readonly kpiNBI = new NBIKpis();
  private readonly attr = new NbiDimensions();
  public constructor() {
    super();

    this.key = "nbi_export_deal_data";
    const storedData = localStorage.getItem(this.key);
    if (storedData === null || storedData === undefined) {
      this.defaultData = { level: this.kpiNBI.NBI_YTD, top: undefined };
    } else {
      this.defaultData = JSON.parse(storedData) as IStoredData;
      if (
        [
          this.kpiNBI.NBI_YTD,
          this.kpiNBI.NBI_MTD,
          "last_day",
          "specific",
        ].indexOf(this.defaultData.level) <= -1
      ) {
        this.defaultData.level = this.kpiNBI.NBI_YTD;
      }
    }
    this.setState({
      btnText: "Export ",
      dataLevel: "ready",
      fromDate: this.currentDate.toISOString().slice(0, 4) + "-01-01",
      level: this.defaultData.level,
      specificFromDate: this.currentDate.toISOString().slice(0, 4) + "-01-01",
      specificToDate: this.currentDate.toISOString().slice(0, 10),
      spinnerClass: "",
      toDate: this.currentDate.toISOString().slice(0, 10),
      top: this.defaultData.top,
    });
    this.downloadCsv = this.downloadCsv.bind(this);
    this.setState({
      date: `${this.state.fromDate}:${this.state.toDate}`,
    });
  }

  public MakeDecisionOnInheritedFilterInPortfolioCase(
    currentFilters: string
  ): string {
    return currentFilters.indexOf(this.attr.CLIENT_GEN_ID) === -1
      ? `${currentFilters},${inheritedFilter}`
      : currentFilters;
  }

  protected shouldFetchApiData(nextProps: IProps): boolean {
    return true;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div class="container" style="width: 100%; height: 100%">
        <div class="row">
          <div class="container col-12" style="width: 100%">
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b>Time Period</b>
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === this.kpiNBI.NBI_YTD}
                  onClick={this.timePeriodClicked.bind(
                    this,
                    this.kpiNBI.NBI_YTD
                  )}
                />{" "}
                Year-To-Date
              </div>
              <div class="col-md-2">
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === "last_day"}
                  onClick={this.timePeriodClicked.bind(this, "last_day")}
                  style="margin-left: 15px"
                />{" "}
                Last Day
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === this.kpiNBI.NBI_MTD}
                  onClick={this.timePeriodClicked.bind(
                    this,
                    this.kpiNBI.NBI_MTD
                  )}
                  style="margin-left: 15px"
                />{" "}
                Month-To-Date
              </div>
            </div>
            <br />
            <div class="row" style="margin-left: 1px">
              <div
                class="col-md-3 col-md-offset-1"
                style="text-align: right;padding-right: 0px;"
              >
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === "specific"}
                  onClick={this.timePeriodClicked.bind(this, "specific")}
                />{" "}
                Specific Date Range
              </div>
              <div class="col-md-8">
                <DealListDateRange
                  onChangeFromDate={this.onChangeFromDate}
                  onChangeToDate={this.onChangeToDate}
                />
              </div>
            </div>
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b> Nb of rows </b>
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="rows"
                  checked={this.state.top === undefined}
                  onClick={this.rowNbrClicked.bind(this, undefined)}
                />{" "}
                All Data(up to 200000 rows)
              </div>
              <div class="col-md-2">
                <input
                  type="radio"
                  name="rows"
                  checked={this.state.top === 100}
                  onClick={this.rowNbrClicked.bind(this, 100)}
                  style="margin-left: 15px"
                />{" "}
                Top 100
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="rows"
                  checked={this.state.top === 10}
                  onClick={this.rowNbrClicked.bind(this, 10)}
                  style="margin-left: 15px"
                />{" "}
                Top 10
              </div>
            </div>
            <br />
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b>Select filter(s) </b>
              </div>
              <div class="col-md-10">
                Please use board filters or local filters
              </div>
            </div>
            <br />
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b>Select Columns </b>
              </div>
              <div class="col-md-10">
                Please use 
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAH3SURBVEhLxZZLLwNRFMf/d1qdvvQhIqULNlZsPEITlhIfwlosiUisrKx8BEufwJqNiE9gKyylJKWtPlX1Omd6OzpaOmqmfslk5pzF3P8595xzr5BS4ieKVchaHag3gAY9dvBowJAHiIUglMuCEE13OitnvxWQK0NWa8r4A14SMjpsFdImIEVarZRrkA85ZxZn6u8A/y9fgRlpW9ArFgGc7peyMhym8grkKavKbDFtCuDISYCrVCirBQpSmcyZKcCtyL9SsgaZNgRwwRnmgMiWQH1lkDC6gItEObqSuQHuisqwQdgLTCboPaYcnaTH42KCuiAuChXZc++vT4CNa2XYYDUOHKwDySXl6CQX0rFVesWpeCpIY9AMmAYNqvO3d2xqPOH+AV53md4pQftguwAzV8D+hTK6MBUFtteAyIxy/AxNBhx2TMIBwvN4WDzmpbR7yDgJHQc1yv2x5v2nHKh1heajnu2HzDkwuwvM7wHPl8r5C1rramF/9zO7F3oS2FsEdhboZzR0fkskKHR+G5PQqbPfLvoQMBIW3IFHxk7Egv1loV/inzelW7MEI0H14TIhv/pocmMKCPogqB5cJeCjxqeaa13JiHtLE3JBupWJAJVctHOrGxYBDGciEYPwk1on4Esp/y8aaC7eFj0zMfBrebuAdFbOfQAYaq66l2S4BgAAAABJRU5ErkJggg==" />{" "}
                (top right corner )
              </div>
            </div>
            <br />
            <div class="row" style="margin-left: 45px">
              <div class="col-md-2">
                <button
                  class="btn btn-primary"
                  onClick={() => this.downloadCsv()}
                >
                  {this.state.btnText}
                  <i class={this.state.spinnerClass} />
                </button>
              </div>
            </div>
            <div
              style={
                this.state.dataLevel === "no-access-rights" ? "" : displayNone
              }
            >
              <UserActionOnAuthErrorMessage message={this.state.statusText} />
            </div>
            <div
              style={this.state.dataLevel === "no-client" ? "" : displayNone}
            >
              <UserActionRequiredMessage message="Please select a client" />
            </div>
            <div
              style={
                this.state.dataLevel === "no-client-mapping" ? "" : displayNone
              }
            >
              <RawUserMessage>
                <span>
                  This client is not in your iC portfolio.
                  <br />
                  Please go to{" "}
                  <a href="https://ic.sgmarkets.com">
                    https://ic.sgmarkets.com
                  </a>
                  , search for the client and click “Add to my portfolio”
                </span>
              </RawUserMessage>
            </div>
            <div
              style={this.state.dataLevel === "server-error" ? "" : displayNone}
            >
              <ServerErrorMessage />
            </div>
            <div
              style={
                this.state.dataLevel === "client-request-error"
                  ? ""
                  : displayNone
              }
            >
              <NoUserActionMessage message="Client Request Error - Possible Timeout" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    let columnsSelected: any;

    if (
      props.filters !== undefined &&
      props.filters.columns &&
      props.filters.columns.length > 0
    ) {
      columnsSelected = props.filters.columns;
    }
    const filters = BuildPortfolioFilters(props.filters);
    const isClientMandatory =
      props.attribute === this.attr.CLIENT_GEN_ID &&
      filters.filter(x => x.attribute === this.attr.CLIENT_GEN_ID).length === 0;
    if (isClientMandatory) {
      this.setState({ dataLevel: "no-client" });
      return;
    }
    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setDataStatus("too-many-clients");
      return;
    }
    this.setState({ dataLevel: "" });
    this.setDataStatus("ready");
    const dateFilter = GetPortfolioFilterAsofDate(props.filters);
    if (dateFilter) {
      this.setState({ toDate: dateFilter.slice(0, 10) });
    }
    this.attributes = getDefaultAttributes();
    this.kpis = getDefaultKpis();
    this.setState({ filters: GenericFilterBuilder(filters) });
    this.setState({
      attrsSelected: this.attributes
        .map(x => x.field)
        .sort()
        .join(","),
      kpisSelected: this.kpis
        .map(x => x.field)
        .sort()
        .join(","),
    });
    this.setState({
      visibleAttributes: this.attributes,
      visibleKpis: this.kpis,
    });
    if (columnsSelected !== undefined && columnsSelected.length > 0) {
      const attrs = getAttrsWithColsSelected(columnsSelected);
      const kpis = getKpisWithColsSelected(columnsSelected);
      this.setState({
        attrsSelected: attrs
          .map(x => x.field)
          .sort()
          .join(","),
        kpisSelected: kpis
          .map(x => x.field)
          .sort()
          .join(","),
        visibleAttributes: attrs,
        visibleKpis: kpis,
      });
    }
    this.setDateOnLevel();
  }

  private readonly onChangeFromDate = (value: any) => {
    this.timePeriodClicked("specific");
    this.setState({ specificFromDate: value });
    this.setDateOnLevel();
  };
  private readonly onChangeToDate = (value: any) => {
    this.timePeriodClicked("specific");
    this.setState({ specificToDate: value });
    this.setDateOnLevel();
  };

  private timePeriodClicked(newLevel: string) {
    this.setState({ level: newLevel });
    this.fetchApiData(this.props);
    this.saveUserPreference();
  }

  private setDateOnLevel() {
    switch (this.state.level) {
      case "nbi_ytd": {
        this.setState((prevState: IState) => ({
          date: prevState.toDate.slice(0, 4) + "-01-01:" + prevState.toDate,
        }));
        break;
      }
      case "nbi_mtd": {
        this.setState((prevState: IState) => ({
          date: prevState.toDate.slice(0, 7) + "-01:" + prevState.toDate,
        }));
        break;
      }
      case "specific": {
        this.setState((prevState: IState) => ({
          date: prevState.specificFromDate.concat(
            ":",
            prevState.specificToDate
          ),
        }));
        break;
      }
      case "last_day": {
        const prevDate = new Date(new Date().setDate(new Date().getDate() - 1))
          .toISOString()
          .slice(0, 10);
        this.setState({
          date: prevDate + ":" + this.currentDate.toISOString().slice(0, 10),
        });
        break;
      }
    }
  }

  private MakeGenricRequestDto(
    arrsSelected: string,
    kpisSelected: string,
    visibleAttributes: any[],
    visibleKpis: any[],
    attributes?: string
  ) {
    let calculatedFilter = "";
    if (attributes !== this.attr.CLIENT_GEN_ID) {
      calculatedFilter = this.state.filters
        ? this.MakeDecisionOnInheritedFilterInPortfolioCase(this.state.filters)
        : inheritedFilter;
    } else {
      if (this.state.filters) {
        calculatedFilter = this.state.filters;
      }
    }
    const genericRequest: IGenericRequest = {
      aggregationAttributes: arrsSelected,
      date: this.state.date,
      filter: calculatedFilter,
      kpis: kpisSelected,
      sort: `-${visibleKpis[0].field}`,
      topN: this.state.top,
    };
    const genericColumnsList: IGenericColumns[] = [];
    for (const element of visibleAttributes) {
      genericColumnsList.push({
        decimal: 0,
        divisor: 0,
        header: element.headerName,
        id: element.field,
      });
    }
    for (const element of visibleKpis) {
      genericColumnsList.push({
        decimal: 3,
        divisor: 1000,
        header: element.headerName,
        id: element.field,
      });
    }
    return {
      genericAggregateDto: genericRequest,
      columns: genericColumnsList,
    };
  }

  private async downloadCsv() {
    this.initCorrelationId();
    this.setState({ spinnerClass: "fa fa-spinner fa-spin" });
    let genericCsvRequest: IGenericCsvRequest;
    genericCsvRequest = this.MakeGenricRequestDto(
      this.state.attrsSelected,
      this.state.kpisSelected,
      this.state.visibleAttributes,
      this.state.visibleKpis,
      this.props.attribute
    );

    try {
      const responseData = await MakeBackgroundExportDataApiCall(
        this.props.headers,
        "nbi",
        genericCsvRequest,
        "DealList.xlsx",
        this.props.widgetConfiguration,
        this.state.correlationId
      );
      const errorStatus = HandleCsvCallErrors(responseData);
      if (errorStatus) {
        this.setState({
          dataLevel: errorStatus,
          statusText: responseData.statusText,
        });
      }
      this.setState({ spinnerClass: "" });
    } catch (e) {
      this.setState({
        dataLevel: "server-error",
        spinnerClass: "",
      });
    }
  }

  private rowNbrClicked(newTop?: number) {
    this.setState({ top: newTop });
    this.fetchApiData(this.props);
    this.saveUserPreference();
  }

  private saveUserPreference() {
    const dataSotored = {
      level: this.state.level,
      top: this.state.top,
    } as IStoredData;
    localStorage.removeItem(this.key);
    localStorage.setItem(this.key, JSON.stringify(dataSotored));
  }
}
export const NbiExportDealList = withWidgetConfiguration(
  NbiExportDealListClass
);
